import Data from '../data';
import Utils from '../utils';

const { Communication, Session } = Utils;
const { ResubmitStatus } = Data;

export class Util {
	static isInResubmitState = () => {
		const { internalAccountDetails = {} } = Session.getAccountInfo();
		const { status = '' } = internalAccountDetails.resubmit || {};

		return (
			status === ResubmitStatus.PaymentResubmission ||
			status === ResubmitStatus.NonCorrectablePaymentResubmission
		);
	};

	/**
	 * Per WEBAPPS-26175, system calls swsim ResubmitPurchase endpoint if user's
	 * account is in resubmit state. After that, system updates Session account
	 * info data.
	 * @return {object}
	 */
	static resubmitPurchase = async () => {
		const { internalAccountDetails = {} } = Session.getAccountInfo();
		const { cookie } = internalAccountDetails.resubmit || {};
		const response = await Communication.resubmitPurchase({
			resubmitCookie: cookie,
		});

		// after the successful call, update session data
		if (Communication.isSuccessful(response)) {
			await Session.loadAccountInfo();
		}

		// return the response to the caller
		return response;
	};
}
